module.exports = __webpack_public_path__ + "img/3.a9a71c38.png";